module.exports = __webpack_public_path__ + "static/media/client-sei.c2ed383c.png";